<template>
  <div class="google-signin-wrapper">
    <div v-if="missingClientId" class="google-signin-error">
      Missing `VUE_APP_GOOGLE_CLIENT_ID`
    </div>
    <div v-else ref="buttonContainer"></div>
  </div>
</template>

<script>
export default {
  name: "GoogleSignInButton",
  emits: ["success", "error"],
  data() {
    return {
      missingClientId: !process.env.VUE_APP_GOOGLE_CLIENT_ID,
      scriptReadyAttempts: 0,
      rendered: false,
    };
  },
  async mounted() {
    if (this.missingClientId) return;
    try {
      await this.ensureGoogleScriptLoaded();
    } catch (error) {
      this.$emit("error", error);
      return;
    }
    this.tryRender();
  },
  methods: {
    ensureGoogleScriptLoaded() {
      return new Promise((resolve, reject) => {
        if (window.google?.accounts?.id) {
          resolve();
          return;
        }

        const src = "https://accounts.google.com/gsi/client";
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) {
          existing.addEventListener("load", () => resolve(), { once: true });
          existing.addEventListener(
            "error",
            () => reject(new Error("Google sign-in script failed to load")),
            { once: true }
          );
          return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () =>
          reject(new Error("Google sign-in script failed to load"));
        document.head.appendChild(script);
      });
    },
    tryRender() {
      const maxAttempts = 40;
      if (window.google?.accounts?.id && this.$refs.buttonContainer && !this.rendered) {
        window.google.accounts.id.initialize({
          client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          callback: (response) => {
            if (!response?.credential) {
              this.$emit("error", new Error("Google sign-in failed"));
              return;
            }
            this.$emit("success", response.credential);
          },
        });
        window.google.accounts.id.renderButton(this.$refs.buttonContainer, {
          theme: "outline",
          size: "large",
          shape: "pill",
          text: "signin_with",
          width: 280,
        });
        this.rendered = true;
        return;
      }

      this.scriptReadyAttempts += 1;
      if (this.scriptReadyAttempts < maxAttempts) {
        setTimeout(() => this.tryRender(), 150);
      } else {
        this.$emit("error", new Error("Google sign-in script failed to load"));
      }
    },
  },
};
</script>

<style scoped>
.google-signin-wrapper {
  display: flex;
  justify-content: center;
}

.google-signin-error {
  color: #dc3545;
  font-size: 0.9rem;
}
</style>
